exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-core-video-player-control .btn-pip svg{width:22px}", ""]);

// exports
